import '../assets/cssFiles/header.css';

import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';

export default  class Header extends Component{
    constructor(props){
        super(props);
        this.state={
            showErweima: false
        }
    }
    render(){
        return(
            <header className="container header">
                <img className="logo" src={require('../assets/images/logo.png')} alt='选考在线'/>
                <ul className="top-menu-wrapper">
                    <li><NavLink activeClassName="active" to='/' exact>首页</NavLink></li>
                    <li className="sub-menu-wrapper-li">
                        <NavLink activeClassName="active" to='/five'>五大模块</NavLink>
                        <ul className="sub-menu-wrapper wrapper-height-1">
                            <NavLink activeClassName="sub-menu-active" to="/five" exact>选考在线平台</NavLink>
                            <NavLink activeClassName="sub-menu-active" to="/five/getcareer">壹志愿平台</NavLink>
                            <NavLink activeClassName="sub-menu-active" to="/five/career">智慧生涯系统</NavLink>
                            <NavLink activeClassName="sub-menu-active" to="/five/eduction">升学教育活动</NavLink>
                            <NavLink activeClassName="sub-menu-active" to="/five/online">书籍出版</NavLink>
                        </ul>
                    </li>
                    <li className="sub-menu-wrapper-li">
                        <NavLink activeClassName="active" to='/three'>三大群体</NavLink>
                        <ul className="sub-menu-wrapper wrapper-height-2">
                            <NavLink activeClassName="sub-menu-active" to="/three" exact>高中生</NavLink>
                            <NavLink activeClassName="sub-menu-active" to="/three/senionHighSchool">高中学校</NavLink>
                            <NavLink activeClassName="sub-menu-active" to="/three/Collage">高等院校</NavLink>
                        </ul>
                    </li>
                    <li><NavLink activeClassName="active" to='/contact'>最新资讯</NavLink></li>
                    <li className="sub-menu-wrapper-li">
                        <NavLink activeClassName="active" to='/about'>关于我们</NavLink>
                        <ul className="sub-menu-wrapper wrapper-height-3">
                            <NavLink activeClassName="sub-menu-active" to="/about" exact>团队介绍</NavLink>
                            <NavLink activeClassName="sub-menu-active" to="/about/software">软著专利</NavLink>
                            <NavLink activeClassName="sub-menu-active" to="/about/address">联系方式</NavLink>
                            <NavLink activeClassName="sub-menu-active" to="/about/web">手机主页</NavLink>
                        </ul>
                    </li>
                    <li><NavLink activeClassName="active" to='/partnership'>合伙人计划</NavLink></li>
                </ul>
                <div className="erweima hand" onMouseEnter={()=>{this.setState({showErweima: true})}} onMouseLeave={()=>{this.setState({showErweima: false})}}>扫码进入手机主页</div>
                {this.state.showErweima ? <img className="erweima_img" src={require('../assets/images/top_erweima.png')} alt='选考在线'/> : null}
            </header>
        )
    }
}
